/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'DrivingBehavior',
    path: '/driving-behavior/index',
    component: () =>
      import(
        /* webpackChunkName: "DrivingBehavior" */
        '@/views/driving-behavior'
      ),
    meta: { title: '驾驶行为' },
  },
  {
    name: 'DrivingBehaviorRule',
    path: '/driving-behavior/rule',
    component: () =>
      import(
        /* webpackChunkName: "DrivingBehaviorRule" */
        '@/views/driving-behavior/rule'
      ),
    meta: { title: '疲劳驾驶规则说明' },
  },
];
